import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UtilService } from 'src/app/services/util.service';
import { ToastrService } from 'src/app/shared/ui/toastr/toastr.service';
import { NewContractLargeAccounts } from '../../new-contract-large-accounts.model';
import { NewContractLargeAccountsService } from '../../new-contract-large-accounts.service';
import { NewContractModalSignComponent } from '../new-contract-modal-sign/new-contract-modal-sign.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-new-contract-sign',
  templateUrl: './new-contract-sign.component.html',
  styleUrls: ['./new-contract-sign.component.scss']
})
export class NewContractSignComponent implements OnDestroy {
  public selectForm: FormGroup = new FormGroup({ typeSign: new FormControl(null) });
  public radioSelected = 0;
  public digitalType = false;
  public paperType = false;
  private destroyed$: Subject<boolean> = new Subject<boolean>();

  @Input() idContract: string;
  @Input() dataForms: NewContractLargeAccounts;
  @Input() codTraddingAccount: string;
  @Input() fromOffer: boolean;
  @Output() changeLoader: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private matDialog: MatDialog,
    private toastrService: ToastrService,
    private newContractLargeAccountsService: NewContractLargeAccountsService,
    private utilService: UtilService,
    private location: Location
  ) { }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public handleToggle(option: number): void {
    if (option === 0) {
      this.digitalType = true;
      this.paperType = false;
      this.openDialog(true);
    } else {
      this.digitalType = false;
      this.paperType = true;
    }
  }

  private openDialog(isDigital: boolean): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      autoFocus: false,
      width: '575px',
      disableClose: true,
      data: { isDigital, idContract: this.idContract }
    };
    const dialogRef = this.matDialog.open(NewContractModalSignComponent, dialogConfig.data);
    dialogRef.afterClosed().pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.digitalType = false;
      this.paperType = false;
    });
  }

  public handleDownload(): void {
    this.changeLoader.emit(true);
    this.toastrService.success('NEW_CONTRACT_LA.DOWNLOADING_FOR_SIGNATURE');
    let params = {};
    if (this.fromOffer) {
      params = {
        CodigoCRMContrato: this.idContract,
        CodCRMOferta: this.dataForms.codigoOferta
      };
    } else {
      params = {
        CodigoCRMContrato: this.idContract,
        CodCRMCuentaNegociadora: this.codTraddingAccount
      };
    }

    this.newContractLargeAccountsService.paperSign(params).pipe(takeUntil(this.destroyed$)).subscribe(
      (response: Blob) => {
        if (response.type !== 'application/json') {
          const downloadURL = URL.createObjectURL(response);
          this.toastrService.success('NEW_CONTRACT_LA.DOWNLOADING_SUCCESS');
          window.open(downloadURL);
          this.location.back();
          this.changeLoader.emit(false);
        } else {
          const reader = new FileReader();
          reader.addEventListener('loadend', e => {
            this.toastrService.error(JSON.parse(e.target.result as string).Message);
            this.changeLoader.emit(false);
          });
          reader.readAsText(response);
        }
      },
      error => {
        this.utilService.toastErrors(error);
        this.changeLoader.emit(false);
      }
    );
  }
}
